module.exports = __webpack_public_path__ + "img/lightBulbOff.f9b6aea4.png";